import { render } from "./settings-services.vue?vue&type=template&id=2d008764"
import script from "./settings-services.vue?vue&type=script&lang=js"
export * from "./settings-services.vue?vue&type=script&lang=js"

import "./settings-services.vue?vue&type=style&index=0&id=2d008764&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__